module.exports = __webpack_public_path__ + "img/content4.5fb95bcc.png";